import { colors } from '@insurancemenu/imenu-components-lib';
import { breakpoints, breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import { createUseStyles } from 'react-jss';

const styles = {
  manageDependentModal: {
    maxWidth: '109rem',
    minHeight: '10rem',
    maxHeight: '70vh',

    [breakpoints.xl.down]: {
      maxWidth: '65%',
    },

    [breakpoints.md.down]: {
      maxWidth: '80%',
    },
  },
  modalFooter: {
    display: 'flex',
    justifyContent: 'center',
    gap: '2rem',
    padding: '0 13%',
    marginTop: '4rem',

    [breakpoints.sm.down]: {
      padding: 0,
    },
  },
  dependentSectionContent: {
    position: 'relative',
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    textAlign: 'left',
    boxSizing: 'border-box',
    // form footer
    '& footer': {
      marginBottom: '4rem',
      flexWrap: 'wrap',
    },
  },
  disclaimer: {
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 400 },
    color: colors.neutral[700],
    margin: '0rem auto 4rem',
    letterSpacing: '0.02rem',
    maxWidth: '75%',
    '@media (max-width:1124px)': {
      maxWidth: '100%',
    },
  },
  noDependentsMessage: {
    margin: '5rem auto',
    fontWeight: 700,
  },
  addDependentsButton: {
    margin: '0 auto',

    [breakpointsMQ4.sm.down]: {
      margin: '0 auto 4rem',
    },
  },
  removeDependentButton: {
    textTransform: 'uppercase',
    marginTop: '4rem',
    marginLeft: 'auto',

    [breakpointsMQ4.sm.down]: {
      marginLeft: 0,
      marginTop: '6rem',
    },
  },
  tabs: {
    marginTop: '6rem',
    marginBottom: '1rem',
  },
  formBodyClassName: {
    padding: 0,
    '& > div': {
      '@media (max-width:1124px)': {
        maxWidth: '100%',
      },
    },
  },
  highlightedTabItem: {
    color: colors.green[600],
    '&::after': {
      backgroundColor: colors.green[600],
    },
  },
  closeButton: {
    [breakpoints.sm.down]: {
      width: '100%',
      minWidth: 'unset',
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
